import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-white py-6 px-8 rounded-xl w-[400px]" }
const _hoisted_2 = { class: "text-xl font-semibold mb-6" }
const _hoisted_3 = { class: "mt-4 flex items-center gap-2 bg-primary-300 bg-opacity-20 border border-primary-300 border-opacity-40 text-primary-800 text-sm px-3 py-2.5 rounded-lg" }
const _hoisted_4 = { class: "flex space-x-4 mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseModalButton = _resolveComponent("CloseModalButton")!
  const _component_CustomTextArea = _resolveComponent("CustomTextArea")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_CustomButton = _resolveComponent("CustomButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    "close-esc-event": "keydown",
    "close-button": false,
    "modal-class": "m-auto border-0",
    "mask-class": "grid"
  }, {
    toggle: _withCtx((scope) => [
      _createElementVNode("span", {
        ref: () => _ctx.captureOpenFn(scope.open),
        class: "hidden"
      }, null, 512),
      _renderSlot(_ctx.$slots, "default", {
        open: scope.open,
        close: scope.close
      })
    ]),
    header: _withCtx((scope) => [
      _createVNode(_component_CloseModalButton, {
        onClose: scope.close
      }, null, 8, ["onClose"])
    ]),
    body: _withCtx((scope) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('views.reports.reportsPage.approveDifferenceModal.title')), 1),
        _createVNode(_component_CustomTextArea, {
          value: _ctx.comment,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.comment) = $event)),
          label: _ctx.$t('views.reports.reportsPage.approveDifferenceModal.reasonLabel'),
          required: false,
          "show-required-indication": false,
          maxlength: _ctx.maxLength,
          details: _ctx.commentError,
          "error-state": _ctx.isAtMaxLength,
          onSubmit: ($event: any) => (_ctx.onSave(scope.close))
        }, null, 8, ["value", "label", "maxlength", "details", "error-state", "onSubmit"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Icon, {
            src: _ctx.IconSource.InfoIcon,
            class: "w-4 h-4 flex-shrink-0"
          }, null, 8, ["src"]),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('views.reports.reportsPage.approveDifferenceModal.banner')), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_CustomButton, {
            class: "flex-1",
            "color-preset": "secondary",
            onClick: scope.close
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('views.reports.reportsPage.approveDifferenceModal.cancelButton')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"]),
          _createVNode(_component_CustomButton, {
            class: "flex-1",
            onClick: ($event: any) => (_ctx.onSave(scope.close))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('views.reports.reportsPage.approveDifferenceModal.saveButton')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ])
    ]),
    _: 3
  }))
}